import { QuestionPlanStockTarget as Question } from "@/components/features/items/edit/plan/_shared/ui/components/stock/stock-target";

import { usePlanStockTarget } from "./hooks";

export const QuestionPlanStockTarget = () => {
	const { maxDailyStockNum, stockTypeTarget, onSetMaxDailyStockNum, onSetStockTypeTarget, isEdited, hasError } =
		usePlanStockTarget();

	return (
		<Question
			maxDailyStockNum={maxDailyStockNum}
			stockTypeTarget={stockTypeTarget}
			onSetMaxDailyStockNum={onSetMaxDailyStockNum}
			onSetStockTypeTarget={onSetStockTypeTarget}
			isEdited={isEdited}
			hasError={hasError}
		/>
	);
};
